import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { TranslateService } from '@ngstack/translate';
import { ErrorsService } from 'src/app/services/common/errors.service';
import { SnackBarService } from 'src/app/services/common/snackBar.service';

import * as moment from "jalali-moment";
import { environment } from 'src/environments/environment';
import { CourseService } from 'src/app/services/http/business/course/course.service';
import { SoundEnum } from 'src/app/enums/sound.enum';
import { IError } from 'src/app/interfaces/error.interface';

@Component({
  selector: 'app-set-final-date',
  templateUrl: './set-final-date.component.html',
  styleUrls: ['./set-final-date.component.css']
})
export class SetFinalDateComponent implements OnInit {

  form: FormGroup;
  errors = new Array();
  errObject: any;
  param: any;
  errorList: IError[] = [];

  constructor(
    private fb: FormBuilder,
    private snackBar: SnackBarService,
    private errorService: ErrorsService,
    public translate: TranslateService,
    public courseService: CourseService,
    private dialogRef: MatDialogRef<SetFinalDateComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
      CourseId: [this.data.CourseId, Validators.required],
      FinalExamDate: [this.data.FinalExamDate, Validators.required],
      SendSMSTime: [this.data.SendSMSTime, Validators.required]
    });
  }

  submit(data: any) {

    data.FinalExamDate = moment
      .from(data.FinalExamDate, "en")
      .utc(true)
      .format(environment.dateFormat);

    data.SendSMSTime = moment
      .from(data.SendSMSTime, "en")
      .utc(true)
      .format(environment.dateFormat);

    this.courseService.UpdateFinalExamDate(data).subscribe(
      () => {
        this.dialogRef.close();
        this.snackBar.OpenSnackBar(
          this.translate.get("success.registration"),
          "ok",
          5000,
          SoundEnum.beep
        );
      },
      err => {
        // this.errObject = this.errorService.getError(err);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(err);
        this.errorList = this.errorService.getErrorList(err.error);

      }
    );
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
